import script from "./Inicio.vue?vue&type=script&setup=true&lang=js"
export * from "./Inicio.vue?vue&type=script&setup=true&lang=js"

import "@/assets/plantilla/style.css?vue&type=style&index=0&id=50a37334&scoped=true&lang=css"
import "./Inicio.vue?vue&type=style&index=1&id=50a37334&scoped=true&lang=css"
import "./Inicio.vue?vue&type=style&index=2&id=50a37334&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50a37334"]])

export default __exports__